import { render, staticRenderFns } from "./coachRenewToYouth.vue?vue&type=template&id=3b38d54e&scoped=true&"
import script from "./coachRenewToYouth.vue?vue&type=script&lang=js&"
export * from "./coachRenewToYouth.vue?vue&type=script&lang=js&"
import style0 from "./coachRenewToYouth.vue?vue&type=style&index=0&id=3b38d54e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38d54e",
  null
  
)

export default component.exports